import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet';

import { AiCopilotDrawer } from '../../../components/ai-copilot/AiCopilotDrawer';
import { AiCopilotProvider } from '../../../components/ai-copilot/context/AiCopilotProvider';
import { useAiCopilot } from '../../../components/ai-copilot/context/use-ai-copilot';
import { VyLayout } from '../../../components/new-design/layout/VyLayout';
import { withGlobalSearchParams } from '../../../components/utility/GlobalSearchParamsBoundary';
import { withSuspenseBoundary } from '../../../components/utility/SuspenseBoundary';
import { USAGE_DATA_REPORT_CONTEXT } from '../usage-data-report-suggestions';
import { UnmeteredEventsReportContent } from './unmetered-events-report-components/UnmeteredEventsReportContent';

const UnmeteredEventsReportLayout: React.FC = () => {
  const { isOpen, drawerWidth } = useAiCopilot();

  return (
    <>
      <Box
        sx={{
          transition: (theme) =>
            theme.transitions.create('margin-right', {
              easing: isOpen
                ? theme.transitions.easing.easeOut
                : theme.transitions.easing.sharp,
              duration: isOpen
                ? theme.transitions.duration.enteringScreen
                : theme.transitions.duration.leavingScreen,
            }),
          marginRight: isOpen ? `${drawerWidth}px` : 0,
        }}
      >
        <VyLayout>
          <UnmeteredEventsReportContent />
        </VyLayout>
      </Box>
      <AiCopilotDrawer />
    </>
  );
};

const UNMETERED_EVENTS_SUGGESTIONS = [
  'How many events are unmetered this month?',
  'Which customers have the most unmetered events?',
  'Show me all events with no meter defined',
  'Why is this event showing as "No Contract"?',
  'What do I need to fix to meter these events?',
  'Break down unmetered events by reason',
  'Which meters are disconnected from contracts?',
  'Show the top unmetered events by count',
];

const UnmeteredEventsReportPage: React.FC = () => {
  return (
    <AiCopilotProvider suggestions={UNMETERED_EVENTS_SUGGESTIONS} reportContext={USAGE_DATA_REPORT_CONTEXT}>
      <Helmet>
        <title>Unmetered Events</title>
      </Helmet>
      <UnmeteredEventsReportLayout />
    </AiCopilotProvider>
  );
};

const UnmeteredEventsReportPageWithSuspenseBoundary = withSuspenseBoundary(
  withGlobalSearchParams(UnmeteredEventsReportPage),
);

export { UnmeteredEventsReportPageWithSuspenseBoundary as UnmeteredEventsReportPage };
